import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CategoryIcon from '@material-ui/icons/Category';
import InputLabel from '@material-ui/core/InputLabel';
import Chip from '@material-ui/core/Chip';
import {
  appointmentCategories,
  newAppointmentCategories,
  editAppointmentCategories,
} from '~/config/routes';
import { toast } from 'react-toastify';
import { historyPropType } from '~/config/routerPropTypes';
import Request from '~/providers/Request';
import Context from './context';
import Paper from '~/components/Paper';
import ModalDelete from '~/components/ModalDelete';
import InputShow from '~/components/InputShow';
import PaperButtons from '~/components/PaperButtons';
import AppointmentCategoriesRecord from '~/records/AppointmentCategoriesRecord';
import GridContainer from '~/components/GridContainer';
import GridItem from '~/components/GridItem';
import { AbilityContext } from '~/contexts/Can';

const attrName = (attr) =>
  AppointmentCategoriesRecord.hummanAttributeName(attr);

function ShowAppointmentCategory({ history }) {
  const { id } = history.location.route.getParams();
  const { records, addRecords } = useContext(Context);
  const [record, setRecord] = useState(new AppointmentCategoriesRecord());
  const { t } = useTranslation();
  const [loading, setLoading] = useState(!records || !records[id]);
  const [modal, setModal] = useState(false);
  const ability = useContext(AbilityContext);

  useEffect(() => {
    if (records && records[id]) {
      setRecord(record.updateAttributes(records[id]));
    }
    setLoading(true);
    Request.get(`/admin/appointment_categories/${id}`, {})
      .then((response) => {
        setLoading(false);
        addRecords({ data: [response.data] });
        setRecord(record.updateAttributes(response.data));
      })
      .catch((e) => {
        console.error(e);
        setLoading(false);
      });
  }, []);

  async function handleDelete() {
    setLoading(true);
    Request.del(`/admin/appointment_categories/${id}`)
      .then(() => {
        toast.success(t('delete-toast-success'));
        history.push(appointmentCategories.spec);
      })
      .catch(() => {
        setLoading(false);
        toast.error(t('delete-toast-fail'));
      });
    setModal(false);
  }

  return (
    <Paper
      Icon={CategoryIcon}
      iconColor="purple"
      title={t('appointmentCategories.defSingular')}
      loading={loading}
      actions={
        <PaperButtons
          id={id}
          setModal={ability.can('delete', 'AppointmentCategories') ? setModal : null}
          backRoute={appointmentCategories}
          newRoute={ability.can('new', 'AppointmentCategories') ? newAppointmentCategories : null}
          editRoute={ability.can('edit', 'AppointmentCategories') ? editAppointmentCategories : null}
        />
      }
    >
      <GridContainer>
        <GridItem xs={4} md={4}>
          <InputShow label={attrName('name')} value={record.get('name')} />
        </GridItem>

        <GridItem xs={12}>
          <InputLabel style={{ marginBottom: 10 }}>
            {attrName('tags')}
          </InputLabel>
          {record.get('tags') &&
            record
              .get('tags')
              .map((item) => (
                <Chip
                  style={{ marginRight: 5 }}
                  key={item.id}
                  label={item.name}
                  color="primary"
                />
              ))}
        </GridItem>
      </GridContainer>

      <ModalDelete
        modal={modal}
        onClose={() => {
          setModal(false);
        }}
        name={record.get('name')}
        id={record.get('id')}
        deleteAction={handleDelete}
      />
    </Paper>
  );
}

ShowAppointmentCategory.propTypes = {
  history: historyPropType,
};

export default ShowAppointmentCategory;
